"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var summaryTitleStyles_1 = require("./summaryTitleStyles");
var Translation_1 = require("../../../../../common/components/presentation/Translation/Translation");
var JourneyTypes_1 = require("../../../../../../../common/enum/JourneyTypes");
var SummaryTitle = function (_a) {
    var journeyType = _a.journeyType;
    var style = summaryTitleStyles_1.default();
    var translationId = journeyType === JourneyTypes_1.JourneyTypes.RESERVE_ONLINE
        ? 'trans__checkout__confirmation_page__summary__title_reserve_online_journey'
        : 'trans__checkout__confirmation_page__summary__title';
    return (<core_1.Box className={style.title}>
      <core_1.Typography className={style.name}>
        <Translation_1.default className={style.nameContent} id={translationId}/>
      </core_1.Typography>
    </core_1.Box>);
};
exports.default = SummaryTitle;
